'use client';

import React from 'react';
import { useMedia } from 'react-use';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import styles from './styles.module.scss';

const LogoCarousel = props => {
  const array = props.logos;
  const isMobile = useMedia('(max-width: 768px)');

  return (
    <div className={styles.logoCarousel}>
      <div style={{ textAlign: 'center', fontSize: 12, color: '#ffffffbf' }}>Trusted by</div>
      <div style={{ display: 'flex', gap: 40, justifyContent: 'center' }}>
        {[...Array(isMobile ? 4 : 1)].map((_, containerIndex) => (
          <div key={containerIndex} className={styles.logoContainer}>
            {array.map((url, index) => (
              <Image
                key={index}
                src={url}
                alt={`Partner logo ${index + 1}`}
                width={80}
                height={25}
                style={{ objectFit: 'contain' }}
                className={styles.logo}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const LogoCarouselWrapper = dynamic(() => Promise.resolve(LogoCarousel), {
  ssr: false,
});

export default LogoCarouselWrapper;
